import { AlertResponse, BodyDashboard, BodyChangeStatus, Job, JobResponse } from './tech-admin.models';
import { Injectable } from '@angular/core';
import { TechAdminService } from './tech-admin.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TechAdminStore {
  constructor(private techAdminService: TechAdminService) {}

  bodyDashboard: BodyDashboard = {
    isActive: 'null',
  };

  //Authentication
  getAuthenticationDashboard(): Observable<AlertResponse> {
    return this.techAdminService.postGetAuthenticationDashboard(this.bodyDashboard);
  }
  changeStatusAuthentication(nameAlert: string, statusAlert: string): Observable<any> {
    const body: BodyChangeStatus = {
      name: nameAlert,
      status: statusAlert,
    };
    return this.techAdminService.postChangeStatusAuthentication(body);
  }

  //Signature
  getSignatureDashboard(): Observable<AlertResponse> {
    return this.techAdminService.postGetSignatureDashboard(this.bodyDashboard);
  }
  changeStatusSignature(nameAlert: string, statusAlert: string): Observable<any> {
    const body: BodyChangeStatus = {
      name: nameAlert,
      status: statusAlert,
    };
    return this.techAdminService.postChangeStatusSignature(body);
  }

  //Request
  getRequestDashboard(): Observable<AlertResponse> {
    return this.techAdminService.postGetRequestDashboard(this.bodyDashboard);
  }
  changeStatusRequest(nameAlert: string, statusAlert: string): Observable<any> {
    const body: BodyChangeStatus = {
      name: nameAlert,
      status: statusAlert,
    };
    return this.techAdminService.postChangeStatusRequest(body);
  }

  //Administration
  getAdministrationDashboard(): Observable<AlertResponse> {
    return this.techAdminService.postGetAdministrationDashboard(this.bodyDashboard);
  }
  changeStatusAdministration(nameAlert: string, statusAlert: string): Observable<any> {
    const body: BodyChangeStatus = {
      name: nameAlert,
      status: statusAlert,
    };
    return this.techAdminService.postChangeStatusAdministration(body);
  }

  //Jobs
  getJobsDashboard(): Observable<JobResponse> {
    return this.techAdminService.postGetJobsDashboard();
  }
  changeStatusJob(nameJob: string, statusJob: string): Observable<any> {
    return this.techAdminService.postChangeStatusJob(nameJob, statusJob);
  }
}
